import {isUserBlockedFromPushingByAuthorizationPolicy} from '../json-api-helpers'
import {mergeabilityStatus} from '../mergeability-status'
import {BaseSectionStatus} from './base-section-status'
import type {StackSectionStatus} from './stack-section-status'
import type {JSONAPIPullRequestPayload, PullRequestMergeRequirementsPayload} from '../../page-data/payloads/merge-box'
import type {StatusChecksPageData} from '../../page-data/payloads/status-checks'
import type {FeatureStates} from '@github-ui/pull-requests/page-data/payloads/header'
import type {StackMergeabilityPageData} from '../../page-data/payloads/stack-mergeability'
import type {UseQueryResult} from '@github-ui/react-query'

// the merge section doesn't have a state to rollup - it responds to and can change overall status based on user interaction
// but we need to have a type to use the BaseSectionStatus class
type MergeSectionStatusType = 'UNKNOWN'
type StackSectionInfo = Pick<StackSectionStatus, 'isStacked'>

export class MergeSectionStatus extends BaseSectionStatus<MergeSectionStatusType> {
  #stackSection: StackSectionInfo

  constructor(
    pullRequest: JSONAPIPullRequestPayload,
    mergeRequirements: PullRequestMergeRequirementsPayload | null,
    statusChecks: StatusChecksPageData | undefined,
    featureStates: FeatureStates,
    stackMergeabilityQueries: Array<UseQueryResult<StackMergeabilityPageData>> | undefined,
    stackSection: StackSectionInfo,
  ) {
    super(pullRequest, mergeRequirements, statusChecks, featureStates, stackMergeabilityQueries)
    this.#stackSection = stackSection
  }

  override get shouldRender() {
    return this.canUserPushToBase && !this.isUserBlockedFromPushing
  }

  // don't include the merge section in the overall status calculation
  override get shouldConsiderStatus(): boolean {
    return false
  }

  get canUserPushToBase() {
    const userStateCondition = this.mergeRequirements?.conditions.find(
      condition => condition.type === 'PULL_REQUEST_USER_STATE',
    )

    return userStateCondition?.result === 'PASSED'
  }

  get isUserBlockedFromPushing() {
    return isUserBlockedFromPushingByAuthorizationPolicy(this.mergeRequirements)
  }

  get mergeabilityStatus() {
    return mergeabilityStatus({
      pullRequest: this.pullRequest,
      mergeRequirements: this.mergeRequirements,
      statusChecksData: this.statusChecks,
    })
  }

  get baseRefName() {
    return this.#stackSection.isStacked ? this.pullRequest.stackedBaseRefName : this.pullRequest.baseRefName
  }
}
